module.exports = require('./helpers/bundle-url').getBundleURL('cqLDD') + "404_Icon.27444c3a.png";